import { render, staticRenderFns } from "./modalChangeCustomertoCardAssociation.vue?vue&type=template&id=2b12cf73&"
import script from "./modalChangeCustomertoCardAssociation.vue?vue&type=script&lang=js&"
export * from "./modalChangeCustomertoCardAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports